import { commentService } from '../_services'
import { subSort } from '../_helpers/subsort'

const state = {
  comments: null,
  commentsStatus: {},
  postCommentStatus: {}
}

const actions = {
  postComment ({ commit }, comment) {
    commit('postCommentRequest', comment)
    commentService.postComment(comment)
      .then(
        response => commit('postCommentSuccess', response),
        error => commit('postCommentFailure', error)
      )
  },
  getComments ({ commit }, testUuid) {
    commit('getCommentsRequest')
    commentService.getComments(testUuid)
      .then(
        comments => commit('getCommentsSuccess', comments),
        error => commit('getCommentsFailure', error)
      )
  },
  clearComments ({ state }) {
    state.comments = []
  }
}

const mutations = {
  postCommentRequest (state, comment) {
    state.postCommentStatus = { loading: true }
  },
  postCommentSuccess (state, comment) {
    state.postCommentStatus = { }
    state.comments.push(comment)
  },
  postCommentFailure (state, error) {
    state.postCommentStatus = { error: error }
  },
  getCommentsRequest (state) {
    state.commentsStatus = { loading: true }
  },
  getCommentsSuccess (state, comments) {
    // create check array
    var checkArray = null
    if (state.comments.length >= 50) {
      checkArray = state.comments.slice(-50)
    } else {
      checkArray = state.comments
    }

    // prevent pushing duplicated items
    comments.forEach(comment => {
      var found = !checkArray.every(c => c.uuid !== comment.uuid)

      if (!found) {
        state.comments.push(comment)
      }
    })

    // sort comments accending
    var itemCount = state.comments.length
    var startIndex = 0
    if (state.comments.length >= 50) {
      itemCount = 50
      startIndex = state.comments.length - 50
    }
    subSort(state.comments, startIndex, itemCount, (a, b) => a.created_at - b.created_at)

    state.commentsStatus = { }
  },
  getCommentsFailure (state, error) {
    state.commentsStatus = { error: error }
  }
}

export const comment = {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/_store/comment.module.js